var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"harvest-result-table"},[(_vm.rows)?_c('div',[_c('agro-responsive-table',{attrs:{"columnsLabel":_vm.columnsLabel,"rows":_vm.rows,"tableColumns":_vm.tableColumns,"prefix":_vm.prefix},scopedSlots:_vm._u([{key:"analysisYear",fn:function(ref){
var analysisYear = ref.analysisYear;
return [_c('span',[_vm._v(_vm._s(analysisYear))])]}},{key:"averagePlantingDate",fn:function(ref){
var averagePlantingDate = ref.averagePlantingDate;
return [_c('span',[_vm._v(_vm._s(_vm._f("formattedDate")(averagePlantingDate)))])]}},{key:"averageHarvestDate",fn:function(ref){
var averageHarvestDate = ref.averageHarvestDate;
return [_c('span',[_vm._v("\n          "+_vm._s(_vm._f("formattedDate")(averageHarvestDate))+"\n        ")])]}},{key:"cycle",fn:function(ref){
var averageDates = ref.row;
return [_vm._v("\n        "+_vm._s(_vm.differenceInDays(
            averageDates.averageHarvestDate,
            averageDates.averagePlantingDate
          ))+"\n      ")]}},{key:"harvestSeason",fn:function(ref){
          var harvestSeason = ref.harvestSeason;
return [_c('span',[_vm._v(_vm._s(harvestSeason))])]}},{key:"averageYield",fn:function(ref){
          var averageYield = ref.averageYield;
          var harvestResult = ref.row;
return [_c('div',[_vm._v("\n          "+_vm._s(_vm._f("formattedYield")(averageYield,harvestResult.cropType))+"\n        ")])]}},{key:"production",fn:function(ref){
          var production = ref.production;
          var harvestResult = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm._f("formattedProduction")(production,harvestResult.cropType)))])]}}],null,false,3049069445)})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }